<template>
  <span />
</template>
<script>
export default {
  name: 'DocEvent',
  created () {
    this.bind()
  },
  activated () {
    this.bind()
  },
  destroyed () {
    this.unbind()
  },
  deactivated () {
    this.unbind()
  },
  methods: {
    bind () {
      window.addEventListener('touchstart', this.touchstart)
      window.addEventListener('touchmove', this.touchmove)
      window.addEventListener('touchend', this.touchend)
      window.addEventListener('scroll', this.onScroll)
      window.addEventListener('resize', this.onReSize)
      window.addEventListener('visibilitychange', this.onVisibilitychange)
    },
    unbind () {
      window.removeEventListener('touchstart', this.touchstart)
      window.removeEventListener('touchmove', this.touchmove)
      window.removeEventListener('touchend', this.touchend)
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onReSize)
      window.removeEventListener('visibilitychange', this.onVisibilitychange)
    },
    onScroll (e) {
      this.$emit('scroll', e)
    },
    onReSize (e) {
      this.$emit('resize', e)
    },
    onVisibilitychange (e) {
      this.$emit('visibilitychange', e)
    },
    touchstart (e) {
      this.$emit('touchstart', e)
    },
    touchmove (e) {
      this.$emit('touchmove', e)
    },
    touchend (e) {
      this.$emit('touchend', e)
    }
  }
}
</script>
